import { createRouter, createWebHistory } from 'vue-router'

import useAppStore from '@/stores/app.js'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // Public
    {
      path: '/',
      name: 'root',
      component: () => import('@/views/Root.vue'),
      meta: {
        public: true,
        group: 'public',
        label: 'Home',
        icon: 'fas fa-fw fa-house',
      },
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/About.vue'),
      meta: {
        public: true,
        group: 'public',
        label: 'About',
        icon: 'fas fa-fw fa-circle-info',
      },
    },

    // Indexes
    {
      path: '/events',
      name: 'events',
      component: () => import('@/views/Events.vue'),
      meta: {
        public: false,
        group: 'indexes',
        label: 'Events',
        icon: 'fas fa-fw fa-calendar',
      },
    },

    // Editors
    {
      path: '/events/:eventUID/edit',
      name: 'event-edit',
      component: () => import('@/views/EventEdit.vue'),
      meta: {
        public: false,
        group: 'editors',
        label: null,
        icon: null,
      },
    },

    // Settings

    // Session
    {
      path: '/sign-in',
      name: 'sign-in',
      component: () => import('@/views/SignIn.vue'),
      meta: {
        public: true,
        group: 'session',
        label: 'Sign In',
        icon: 'fas fa-fw fa-door-open',
      },
    },
  ],
})

router.beforeEach((to, _, next) => {
  const appStore = useAppStore()

  // Always allow public page access
  if (to.meta.public) {
    next()
    return
  }

  // If already signed in, redirect sign-in page to events
  if (appStore.signedIn && to.name === 'sign-in') {
    router.push({ name: 'events' })
    return
  }

  // If _not_ signed in and accessing a public page, go to sign-in
  if (!appStore.signedIn) {
    if (to.name === 'sign-in') {
      next()
    } else {
      router.push({ name: 'sign-in' })
    }
    return
  }

  next()
})

export default router
